import { Formation } from "../types"

export const posfor2es: Formation = {
  id: "posfor2es",
  name: "2",
  category: "6 - 5",
  snapshots: [
    {
      players: [
        {
          x: 7.197100895707325,
          y: 7.0390798552774045
        },
        {
          x: 3.5755640027628437,
          y: 5.787820449154579
        },
        {
          x: 10.620271306738632,
          y: 5.07082094399875
        },
        {
          x: 8.512811293881143,
          y: 3.181007886588075
        },
        {
          x: 5.763629361862493,
          y: 3.754484516175702
        },
        {
          x: 2.18106932281166,
          y: 1.9778774539487194
        }
      ],
      opponents: [
        {
          x: 8.342432056276602,
          y: 6.175049849023671
        },
        {
          x: 4.340356222902432,
          y: 2.6005036093143294
        },
        {
          x: 5.442532556458613,
          y: 4.721023468418646
        },
        {
          x: 7.146543113134241,
          y: 2.7765809563895423
        },
        {
          x: 9.30559602689572,
          y: 3.9852402845448776
        }
      ],
      ball: {
        x: 10.278978846833697,
        y: 4.904354081786234
      },
      goalkeepers: [
        {
          x: 6.925088223875495,
          y: 0.990639234244325
        }
      ]
    }
  ]
}
